module.exports = __webpack_public_path__ + "static/media/SourceHanSansCN-Normal.6ad85947.woff";